export default __webpack_public_path__ + "static/media/chemical-peels.17e7bb03.JPG";